<section class="flex flex-col items-center gap-12">
  <div class="text-center">
    <h2 class="mb-4 text-3xl font-bold">Benefits & Wellness</h2>
    <p class="max-w-2xl text-lg text-gray-600">
      We believe in taking care of our team members with comprehensive benefits
      and a flexible work environment.
    </p>
  </div>

  <div class="grid w-full grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
    <!-- Remote Work -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.home" class="mr-2" />
        <h3 class="text-xl font-bold">Fully Remote</h3>
      </div>
      <p class="text-pretty text-lg">
        Work from anywhere in the world with complete flexibility.
      </p>
    </div>

    <!-- Competitive Compensation -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.dollar-sign" class="mr-2" />
        <h3 class="text-xl font-bold">Competitive Salary</h3>
      </div>
      <p class="text-pretty text-lg">
        Competitive salary and equity compensation packages.
      </p>
    </div>

    <!-- Health Insurance -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.heart" class="mr-2" />
        <h3 class="text-xl font-bold">Health Coverage</h3>
      </div>
      <p class="text-pretty text-lg">
        Global health, dental, and vision insurance coverage.
      </p>
    </div>

    <!-- PTO -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.calendar" class="mr-2" />
        <h3 class="text-xl font-bold">Time Off</h3>
      </div>
      <p class="text-pretty text-lg">
        Generous paid time off policy, including vacation and sick leave.
      </p>
    </div>

    <!-- Equipment -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.laptop" class="mr-2" />
        <h3 class="text-xl font-bold">Home Office Setup</h3>
      </div>
      <p class="text-pretty text-lg">
        Home office equipment stipend to set up your workspace.
      </p>
    </div>

    <!-- Team Retreat -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.plane" class="mr-2" />
        <h3 class="text-xl font-bold">Team Retreat</h3>
      </div>
      <p class="text-pretty text-lg">
        Annual in-person team retreat to connect and collaborate.
      </p>
    </div>

    <!-- Learning -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.book-open" class="mr-2" />
        <h3 class="text-xl font-bold">Learning & Development</h3>
      </div>
      <p class="text-pretty text-lg">
        Opportunities for professional growth and skill development.
      </p>
    </div>

    <!-- Own Projects -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.lightbulb" class="mr-2" />
        <h3 class="text-xl font-bold">Own Projects</h3>
      </div>
      <p class="text-pretty text-lg">
        Opportunities to work on your own projects and explore new ideas.
      </p>
    </div>

    <!-- Flexible Schedule -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.clock" class="mr-2" />
        <h3 class="text-xl font-bold">Flexible Schedule</h3>
      </div>
      <p class="text-pretty text-lg">
        Work on your own schedule with flexible hours that fit your lifestyle.
      </p>
    </div>
  </div>
</section>
